import { Injectable } from "@angular/core";
import { Http, Response, URLSearchParams, RequestOptions } from "@angular/http";
import { UtilService } from "../util";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/of";
import { UserPhlebotomist } from "../../models/phlebotomists.model";

@Injectable()
export class PhlebotomistService {
  constructor(private http: Http, private utilService: UtilService) {}

  getAllPhlebotomists(searchCriteria: SearchCriteria) {
    let url = "/phlebotomist";
    let queryParams = this.utilService.setQueryParams({
      page: searchCriteria.PageNumber,
      sort: searchCriteria.Sort,
      order: searchCriteria.Order,
      search: searchCriteria.SearchTerm
    });
    let options = new RequestOptions({ params: queryParams });
    return this.http
      .get(url, options)
      .map((res: Response) => {
        return (this.utilService.outputParser(res) || {}).Phlebotomists || [];
      })
      .catch(this.utilService.handleError);
  }

  getPhlebotomistById(id: number) {
    let url = `/phlebotomist/${id}/profile`;
    return this.http
      .get(url)
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }

  updatePhlebotomist(phlebotomist: UserPhlebotomist) {
    let url = `/phlebotomist/${phlebotomist.Id}/profile`;
    return this.http
      .put(url, phlebotomist)
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }

  createPhlebotomist(phlebotomist: UserPhlebotomist) {
    let url = `/phlebotomist`;
    return this.http
      .post(url, phlebotomist)
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }

  checkPhlebotomistExists(phlebotomist: UserPhlebotomist) {
    let url = "/phlebotomist/exists";
    let queryParams = this.utilService.setQueryParams({
      Id: phlebotomist.Id,
      Email: phlebotomist.Email
    });
    let options = new RequestOptions({ params: queryParams });
    return this.http
      .get(url, options)
      .map((res: Response) => {
        return (this.utilService.outputParser(res) || {}).Exists || false;
      })
      .catch(this.utilService.handleError);
  }

  deactivatePhlebotomist(phlebotomist: UserPhlebotomist) {
    let url = `/user/${phlebotomist.Id}/deactivate`;
    return this.http
      .post(url, {})
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }

  resendActivationEmail(phlebotomist: UserPhlebotomist) {
    let url = `/user/${phlebotomist.Id}/resend`;
    return this.http
      .post(url, {})
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/phlebotomist/phlebotomist.service.ts